import { setAuthenticatedUser } from 'services/appInsights/appInsights';

import authConfigInstance from './authServise';

export const getUserToken = async (forceRefresh = false): Promise<string | undefined | void> => {
  const accessToken = await authConfigInstance
    .getToken(forceRefresh)
    .then(accessTokenResponse => {
      if (accessTokenResponse) {
        setAuthenticatedUser(
          accessTokenResponse.account.username,
          accessTokenResponse.account.localAccountId,
        );

        return accessTokenResponse.accessToken;
      }
    })
    .catch(error => {
      console.error('~~~~~ token ERROR ~~~~~ %o', error);
    });

  return accessToken;
};
